import React from 'react';
import SelectField from 'components/pure/utils/form/SelectField';
import {List} from 'immutable';
import BulbIcon from 'components/pure/scorecards/icons/BulbIcon';

export default class ScorecardQuestionReason extends React.Component {
  render() {
    const {reason, reasonScheme, answer, onReasonChange, questionId} = this.props;

    const entry =
      reasonScheme &&
      reasonScheme.entries.find(
        entry => entry.point + '' === answer || (entry.point === null && answer === 'n/a')
      ); // TODO this is suspect...
    const schemeReasons = entry ? entry.reasons : List();

    if (!schemeReasons.size > 0) return null;

    const optionsFromReasons = Array.concat(
      [
        {
          label: '- select reason for your score -',
          value: undefined,
        },
      ],
      schemeReasons.map(reason => ({label: reason, value: reason})).toArray()
    );

    return (
      <div className="reason-container">
        <BulbIcon />
        <span className="reason-label">Reason</span>
        <SelectField
          className={'reason-options'}
          value={reason}
          tether={true}
          options={optionsFromReasons}
          hideResetButton={true}
          onChange={value => onReasonChange(questionId, value)}
        />
      </div>
    );
  }
}
